export enum ReportLabelEnum {
	'TRAVEL_DISTANCE' = 'Distance parcourue',
	'WORKING_TIME' = 'Temps de travail',
	'TRAVEL_TIME' = 'Temps de trajet',
	'EXTRA_WORKING_TIME' = 'Temps de travail supplémentaire',
	'NOT_USED_WORKING_TIME' = 'Temps de travail non utilisé',
	'NB_SPECIALTIES_UNSATISFIED' = 'Nombre de spécialités insatisfaites',
	'NB_PREFERENCES_RESPECTED' = 'Nombre de préférences respectées',
	'NB_MISSIONS_UNASSIGNED' = 'Nombre de missions non assignées',
	'NB_INTERVENANTS' = "Nombre d'intervenants",
	'WAITING_TIME' = "Temps d'attente",
	'PAYABLE_WAITING_TIME' = "Temps d'attente rémunéré",
	'TW_LATE_ARRIVAL_TIME' = 'Temps de retard cumulé',
	'AVG_TW_LATE_ARRIVAL_TIME' = 'Temps de retard cumulé moyen',
	'SDDistance' = 'Écart-Type Distance'
}
